<template>
    <div>
        <div v-for="data in fjList" :key="data.id">
            <span v-text="data.uploadedFileName"></span>
            <a :href="$URL.API+'/api/common/download?domain='+domian+'&id='+data.id">【附件下载】</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FileDownload",
        props: ["fjList", "domian"],
    }
</script>

<style scoped>

</style>